import React from 'react';
import QRCode from 'react-qr-code';

interface QRCodeGeneratorProps {
  url: string;
  size?: number;
}

const QRCodeGenerator: React.FC<QRCodeGeneratorProps> = ({ url, size = 128 }) => {
  return (
    <div style={{ background: 'white', padding: '16px' }}>
      <QRCode value={url} size={size} />
    </div>
  );
};

export default QRCodeGenerator;